import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { onyxLengthValidator } from './onyx-length.validator';

export const VIN_NUMBER_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;

export const onyxVinNumberValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.value) return null;

  const value = String(control.value);
  const lengthError = onyxLengthValidator(17)(control);
  if (lengthError) return lengthError;

  if (!VIN_NUMBER_PATTERN.test(value)) return { vinNumber: true };

  return null;
};
